import { fork } from 'redux-saga/effects';
import { getHeaderSummary } from './headerSaga';
import { deleteOrder, FilterWatcher, getOrdersByNextOrBack, getOrdersByPage, getOrdersOnRemoveFilter, getOrdersOnTab, getOrdersSaga, postCreateShipment, resetOrderFilter, getSplitOrder } from './orderSaga';
import { quickSearchSaga } from './quicSearchSaga';
import { saveChannelSaga, settingChannelSaga } from './settingChannelSaga';
import { deleteMerchantSaga, fetchMerchantSaga, settingMerchantSaga, updateMerchantSaga, getMasterUpdateSettingSaga, saveMasterUpdateSettingSaga } from './settingMerchantSaga';
import settingPrinterSaga from './settingPrinterSaga';
import { deleteShipments, clearShipmentFeeds, getLabelInfo, getPackageInfo, getPackageInfoShipmentId, getShipmentsByNextOrBack, getShipmentsByPage, getShipmentsSort, getShipmetOnTab, resetShipmentFilter, submitAddPackageInfo, submitShipment, toTransmitedShipment } from './shipmentSaga';
import { syncWatcher } from './syncOrders';
import { getListProhibitedSaga, updateLastCheckedKeywordSaga } from './prohibitedItemsSaga';
import { clearShipmentFailFeed } from '../actions/shipmentAction';

export default function* root() {
    yield fork(settingPrinterSaga)
    yield fork(syncWatcher)
    yield fork(FilterWatcher)
    yield fork(settingChannelSaga)
    yield fork(saveChannelSaga)
    yield fork(settingMerchantSaga)
    yield fork(getMasterUpdateSettingSaga)
    yield fork(saveMasterUpdateSettingSaga)
    yield fork(fetchMerchantSaga)
    yield fork(getOrdersSaga)
    yield fork(getOrdersByPage)
    yield fork(getOrdersByNextOrBack)
    yield fork(getOrdersOnRemoveFilter)
    yield fork(quickSearchSaga)
    yield fork(getOrdersOnTab)
    yield fork(postCreateShipment)
    yield fork(resetOrderFilter)
    yield fork(deleteOrder)
    yield fork(getSplitOrder)

    yield fork(submitShipment)
    yield fork(getShipmentsByPage)
    yield fork(getShipmentsByNextOrBack)
    yield fork(getShipmentsSort)
    yield fork(submitAddPackageInfo)
    yield fork(deleteShipments)
    yield fork(clearShipmentFeeds)
    yield fork(resetShipmentFilter)
    yield fork(getShipmetOnTab)
    yield fork(toTransmitedShipment)
    yield fork(getLabelInfo)
    yield fork(getPackageInfo)
    yield fork(getPackageInfoShipmentId)

    yield fork(deleteMerchantSaga)
    yield fork(updateMerchantSaga)
    yield fork(getHeaderSummary)
    yield fork(getListProhibitedSaga)
    yield fork(updateLastCheckedKeywordSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/index.js